import React, { FC, useState } from "react";
import { AccordionProps } from "@mui/material";

import { StyledMuiAccordion } from "./styled";

export interface IStyledAccordionProps extends AccordionProps {}

export const StyledAccordion: FC<IStyledAccordionProps> = props => {
  const { children, ...rest } = props;

  const [expanded, setExpanded] = useState(true);

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <StyledMuiAccordion expanded={expanded} onChange={handleExpand} {...rest}>
      {children}
    </StyledMuiAccordion>
  );
};
